<template>
  <!-- Główny kontener listy naruszeń -->
  <!-- Dodatkowa klasa 'violations-step-1' usuwa dolną ramkę w kroku 1 -->
  <div class="violations" :class="{ 'violations-step-1': step === 1 }">
    <!-- Nagłówek sekcji: tłumaczenie klucza 'vehicles', wyświetlane wielkimi literami -->
    <!-- Dodajemy lewą ramkę, gdy wybrane są dokładnie 2 lokalizacje -->
    <h3 :class="{ 'with-border-left': this.store.locations.length == 2 }">
      {{ t('violations').toUpperCase() }} %
    </h3>

    <!-- Kontener zawierający checkboxy: jedna kolumna -->
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column all">
        <!-- Nagłówek kolumny: 'VIOLATIONS %' -->
        <!-- <div class="th">{{ t('violations').toUpperCase() }} %</div> -->

        <!-- Checkbox dla filtrowania tylko oznaczonych pojazdów -->
        <div class="d-flex td">
          <div>
            <input-checkbox
              field-name="taggedOnly"
              field-value=""
              :checkedCondition="isChecked('taggedOnly')"
              @clicked="setFilter('taggedOnly')"
              :disabled="store.disabledFields?.violations"
            />
          </div>
          <div class="value">{{ t('tagged-only') }}</div>  <!-- Etykieta obok checkboxa -->
        </div>

        <!-- Checkbox dla opcji "wszystkie" -->
        <div class="d-flex td">
          <div>
            <input-checkbox
              field-name="ViolationsAll"
              field-value=""
              :checkedCondition="isChecked('all')"
              @clicked="setFilter('ViolationsAll')"
              :disabled="store.disabledFields?.violations"
            />
          </div>
          <div class="value">{{ t('all') }}</div>
        </div>

        <!-- Iteracja po poszczególnych typach naruszeń -->
        <div
          class="d-flex td"
          v-for="(item, index) in store.violations"
          :key="index"
        >
          <div>
            <input-checkbox
              :field-name="index"
              field-value=""
              :checkedCondition="isChecked(index)"
              @clicked="setFilter(index)"
              :disabled="store.disabledFields?.violations"
            />
          </div>
          <div class="value">{{ item }}</div>  <!-- Tłumaczona nazwa naruszenia -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Import komponentu checkbox do wielokrotnego użytku
import InputCheckbox from "../InputCheckbox.vue";

export default {
  name: "ViolationList",  // Nazwa komponentu
  props: {
    // Store z filtrami i danymi lokalizacji oraz dostępnymi naruszeniami
    store: { required: true },
    // Obecny krok procesu (np. 1 lub 2)
    step: { type: Number, default: 2 },
  },
  components: { InputCheckbox }, // Rejestracja komponentu InputCheckbox

  created() {
    // Przy tworzeniu komponentu ładujemy listę lokalizacji do store
    this.store.getLocations();
  },

  methods: {
    /**
     * Przełącza wartość filtra dla danego klucza:
     * Jeśli jest już ustawiony, usuwa go; w przeciwnym razie ustawia na true
     */
    setFilter(id) {
      const value = this.store.filters[id] ? false : true;
      this.store.addItem(id, value);
    },

    /**
     * Sprawdza, czy dany filtr jest zaznaczony:
     * - Dla 'all' sprawdzamy, czy wszystkie naruszenia są ustawione na true
     * - Inaczej zwracamy wartość boolean z store.filters
     */
    isChecked(id) {
      if (id === "all") {
        const filters = this.store.filters;
        // Sprawdzamy, czy nie ma żadnego naruszenia bez filtra true
        return !Object.keys(this.store.violations).some(key => filters[key] !== true);
      }
      return this.store.filters[id];
    },
  },
};
</script>

<style scoped>
.violations {
  width: 50%;
  min-height: 140px;
  border-bottom: 1px solid #bfbfbf;
}

.violations-step-1 {
  border-bottom: none !important;
}

.violations h3 {
  padding: 0.85rem 1rem 0.9rem 1rem;
  border-right: 1px solid #bfbfbf;
  margin-bottom: 0;
}

.with-border-left {
  border-left: 1px solid #bfbfbf;
  margin-left: -1px;
}

.th {
  padding: 17px 50px 16px 16px;
  min-height: 24px;
  font-weight: normal;
  font-size: 12px;
  border: 1px solid #bfbfbf;
  margin-left: -1px;
}

.td {
  padding: 14px 120px 13px 16px;
  border-bottom: 1px solid #bfbfbf;
  border-right: 1px solid #bfbfbf;
  border-left: 1px solid #bfbfbf;
  margin-left: -1px;
}

.td:first-child {
  border-top: 1px solid #bfbfbf;
}

.td:nth-child(2) {
  background-color: #f0efec;
}

.td .value {
  margin-left: 20px;
}

.value {
  font-size: 12px;
  margin-top: 3px;
}

.all {
  background-color: white;
  width: 100%;
}
</style>